import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import Divider from '@Components/divider';
import styles from './controlled-list-heading-item.module.scss';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';

export interface ControlledListHeadingItemProps {
  id: string;
  className?: string;
  text: string;
  showDivider?: boolean;
  rightIcon?: string;
  rightIconClassName?: string;
}

export function ControlledListHeadingItem({className = '', rightIconClassName = '', rightIcon = '', showDivider = true, ...props}: ControlledListHeadingItemProps): ReactElement {
  return (
    <li key={props.id} className={` ${styles.container} ${className || ''}`}>
      <div className="flex flex-h-row flex-items-center gap-1">
        <Text className="content-heading" val={props.text} bold size={TextSize.XSMALL} />
        {rightIcon ? <Icon icon={rightIcon} className={rightIconClassName} size={IconSize.SIZE_ICON_16} /> : null}
      </div>
      {showDivider ? <Divider additionalClasses={`${styles.divider} spacing-m-b-2`} /> : null}
    </li>
  );
}
